import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import { colors, fontSize } from '../../constants/styleConstants';

const useStyles = makeStyles(theme => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 15,
  },
  description: {
    fontSize: '0.82rem',
    margin: 0,
    marginTop: 15,
    paddingRight: '30px',
    color: colors.black,
    [theme.breakpoints.down('sm')]: {
      color: colors.white,
    },
  },
}));

const Title = styled.h2`
  line-height: 1;
  font-size: ${props => {
    switch (props.size) {
      case 'large':
        return fontSize.largeTitle;
      case 'small':
        return fontSize.mdTitle;
      case 'extraLarge':
        return fontSize.subTitle;
      default:
        return fontSize.largeTitle;
    }
  }};
  color: ${props => {
    switch (props.color) {
      case 'white':
        return colors.white;
      case 'default':
        return colors.black;
      default:
        return colors.black;
    }
  }};
`;

const TitledDescription = ({ title, description, descColor, size, color }) => {
  const classes = useStyles();

  return (
    <article className={classes.wrapper}>
      <Title size={size} color={color}>
        {title}
      </Title>
      {description && (
        <p style={{ color: colors[descColor] }} className={classes.description}>
          {description}
        </p>
      )}
    </article>
  );
};

TitledDescription.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  descColor: PropTypes.string,
  size: PropTypes.string,
  color: PropTypes.string,
};

export default TitledDescription;
